import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from "rxjs";
import { AppState } from 'src/app/store/app.reducer';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { selectCurrentLang, selectUser } from 'src/app/store/user/user.selector';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import * as UserActions from 'src/app/store/user/user.actions';
import { StandardPageLayout } from '../../stdlayoutlib/classes.stdlayoutlib';
import { User } from 'src/app/model/user';
import { AppComponent } from 'src/app/app.component';
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	templateUrl: './language.dialog.component.html',
	styles: `
		img {
			-webkit-user-drag: none;
			user-drag: none;
		}
	`
})
export class LanguageDialogComponent implements OnInit, OnDestroy {
	currentLang$: Observable<Lang> = new Observable();
	currentLangSub: Subscription | undefined;
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	flagImagePath = './assets/images/flags/';
	flagImageFormat = '.svg';

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public app: AppComponent,
	) {
		this.initSelector();
	}

	initSelector() {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.currentUser$ = this.store.select(selectUser);
	}

	ngOnInit(): void {
		this.currentLang$.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
		this.onResize();
	}

	ngOnDestroy(): void {
		this.currentLangSub?.unsubscribe();
	}

	setLanguage(lang: Lang): void {
		this.store.dispatch(UserActions.setCurrentLang({ lang }));
		setTimeout(() => {
			if (this.currentUser) {
				this.store.dispatch(AnalyticsActions.eventNewAction({ eventName: 'change_language', params: {} }));
			} else {
				this.store.dispatch(AnalyticsActions.eventNoAuth({ eventName: 'change_language', params: {} }));
			}
		}, 2000);
		this.ref.close();
	}

	languageButtonColor(lang: Lang): string {
		return (lang === this.currentLang) ? "bg-primary hover:bg-primary" : "text-color surface-100 hover:surface-500";
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

}
